import { CampaignByProductIdDto } from '@dto/campaign/campaign-by-product-id.dto';
import { CampaignDto } from '@dto/campaign/campaign.dto';
import { ChatCodesByProductIds } from '@dto/campaign/chat-codes-by-product-ids.dto';
import { createAction, props } from '@ngrx/store';

const state = '[Campaign]';

// Init chatCodes 
export const initChatCodesByProductIds = createAction(
  `${state} Init chat codes by productIds`,
  props<{ productIds: string[] }>()
);
export const initChatCodesByProductIdsSuccess = createAction(
  `${state} Init chat codes by productIds success`,
  props<{ chatCodesByProductId: ChatCodesByProductIds }>()
);
export const initChatCodesByProductIdsFailure = createAction(
  `${state} Init chat codes by productIds failure`,
  props<{ error: string }>()
);
// Init campaign
export const initCampaignByProductIds = createAction(
  `${state} Init campaign by productIds`,
  props<{ productIds: string[] }>()
);
export const initCampaignByProductIdsSuccess = createAction(
  `${state} Init campaign by productIds success`,
  props<{ campaignByProductId: CampaignByProductIdDto }>()
);
export const initCampaignByProductIdsFailure = createAction(
  `${state} Init campaign by productIds failure`,
  props<{ error: string }>()
);

// Send campaign
export const sendCampaign = createAction(
  `${state} Send campaign`,
  props<{ campaign: CampaignDto }>()
);
export const sendCampaignSuccess = createAction(
  `${state} Send campaign success`,
  props<{ campaign: CampaignDto }>()
);
export const sendCampaignFailure = createAction(
  `${state} Send campaign failure`,
  props<{ error: string }>()
);
